import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Checkbox } from 'components';
import { getErrorsFromFieldState } from 'components/form/helpers';
const RenderCheckbox = ({ name, label, isRequired, shouldUnregister }) => {
    const { control } = useFormContext();
    return (React.createElement(Controller, { control: control, name: name, render: ({ field, fieldState }) => (React.createElement(Checkbox, { content: label, errors: getErrorsFromFieldState(fieldState, field.name), isChecked: !!field.value, name: field.name, onBlur: field.onBlur, onChange: field.onChange })), rules: { required: isRequired }, shouldUnregister: shouldUnregister }));
};
export default RenderCheckbox;
